// 2017-08-21T22:09:55.617047+00:00
export const FULL_FORMAT = 'YYYY-MM-DDTHH:mm:ssZZ';
export const CUSTOM_FORMAT = 'MMM D, YYYY h:mm:ss a';
